export function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export function capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertSortDir(string) {
    return string === "ascend" ? "ASC" : "DESC"
}

export function isEmptyObj(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export function renderStringValue(inStr) {
    if (!inStr || inStr === ""){
        return "-"
    }
    return inStr
}

export function checkIsNumber(input) {
    if (isNaN(input)){
        return false
    }
    return true
} 

export function prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
}